import { Inbox } from 'lucide-react';
import { Button } from './Button';

export function EmptyState({ title, message, actionLabel, onAction }) {
  return (
    <div className="flex flex-col items-center justify-center rounded-xl border border-dashed border-border bg-card py-12 px-6 text-center">
      <Inbox className="h-10 w-10 text-muted mb-3" />
      <p className="font-medium text-text">{title}</p>
      {message && <p className="mt-1 text-sm text-muted max-w-sm">{message}</p>}
      {actionLabel && onAction && (
        <Button className="mt-4" onClick={onAction}>
          {actionLabel}
        </Button>
      )}
    </div>
  );
}
